import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject
} from '@angular/core';
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_TYPE,
  BUTTON_VARIANT,
  FvButtonComponent,
} from '@discocil/fv-components';
import { qrIconClass } from 'src/app/config/icons.config';
import { QuickActionsWidgetViewModel } from '../../viewmodels/quick-actions-widget/quick-actions-widget.viewmodel';

@Component({
  selector: 'app-quick-actions-widget',
  templateUrl: './quick-actions-widget.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FvButtonComponent, NgClass],
})
export class QuickActionsWidgetComponent {
  BUTTON_SIZE = BUTTON_SIZE;
  BUTTON_COLOR = BUTTON_COLOR;
  BUTTON_TYPE = BUTTON_TYPE;
  BUTTON_VARIANT = BUTTON_VARIANT;

  readonly qrIconClass = qrIconClass;

  readonly viewModel = inject(QuickActionsWidgetViewModel);
  
  onClickScanQR(): void {
    this.viewModel.processManualScanQR();
  }
}
